// Added type alias for module type
type Module = { default?: Record<string, any>; [key: string]: any };

const locales: Record<string, Module> = import.meta.glob('./locales/*.{js,ts}', { eager: true });
const pages: Record<string, Module>   = import.meta.glob('./pages/**/*.{js,ts}', { eager: true });

const payload: Record<string, Record<string, any>> = {};
const getLang = (p: string): string => p.replace(/^.*\/locales\/([^/.]+)\.(?:js|ts)$/, '$1');

// seed from locales
for (const p of Object.keys(locales).sort()) {
  const mod = locales[p];
  const lang = getLang(p);
  payload[lang] = { ...(mod.default ?? mod) };
}

// merge pages (default map or named exports per lang)
for (const p of Object.keys(pages).sort()) {
  const mod = pages[p];
  const def = mod.default ?? {};
  for (const lang of Object.keys(payload)) {
    Object.assign(payload[lang], def[lang] ?? mod[lang] ?? {});
  }
}

export default payload;
